<div class="citations-container" *ngIf="citations && citations.length > 0">
  <div class="citations-header">
    <h3 class="citations-title">
      <mat-icon>source</mat-icon>
      {{ title }}
    </h3>
  </div>

  <!-- Grid Display Style (ChatGPT/Perplexity Style) -->
  <div class="citations-grid" *ngIf="displayStyle === 'grid'">
    <div 
      class="citation-card" 
      *ngFor="let citation of displayedCitations; trackBy: trackByCitationId"
      (click)="openCitation(citation.url)"
      [class.expanded]="isExpanded(citation.id)">
      
      <!-- Citation Header -->
      <div class="citation-header">
        <div class="citation-favicon">
          <img 
            [src]="getFaviconUrl(citation.domain)" 
            [alt]="citation.domain"
            (error)="handleImageError($event)">
        </div>
        <div class="citation-meta">
          <div class="citation-number">[{{ citation.id }}]</div>
          <div class="citation-domain">{{ citation.domain }}</div>
        </div>
        <div class="citation-confidence" [style.background-color]="getConfidenceColor(citation.confidence)">
          {{ (citation.confidence * 100).toFixed(0) }}%
        </div>
      </div>

      <!-- Citation Content -->
      <div class="citation-content">
        <h4 class="citation-title">{{ citation.title }}</h4>
        <p class="citation-snippet" [class.expanded]="isExpanded(citation.id)">
          {{ isExpanded(citation.id) ? citation.snippet : truncateSnippet(citation.snippet, 120) }}
        </p>
      </div>

      <!-- Citation Footer -->
      <div class="citation-footer">
        <button 
          mat-button 
          class="expand-button"
          (click)="toggleExpand(citation.id); $event.stopPropagation()">
          {{ isExpanded(citation.id) ? 'Show Less' : 'Show More' }}
          <mat-icon>{{ isExpanded(citation.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <span class="citation-type" *ngIf="citation.type">{{ citation.type }}</span>
      </div>
    </div>
  </div>

  <!-- List Display Style -->
  <div class="citations-list" *ngIf="displayStyle === 'list'">
    <div 
      class="citation-list-item" 
      *ngFor="let citation of displayedCitations; trackBy: trackByCitationId"
      (click)="openCitation(citation.url)">
      
      <div class="citation-list-header">
        <span class="citation-number">[{{ citation.id }}]</span>
        <img 
          class="citation-favicon-small" 
          [src]="getFaviconUrl(citation.domain)" 
          [alt]="citation.domain"
          (error)="handleImageError($event)">
        <h4 class="citation-list-title">{{ citation.title }}</h4>
        <span class="citation-confidence-badge" [style.background-color]="getConfidenceColor(citation.confidence)">
          {{ getConfidenceLabel(citation.confidence) }}
        </span>
      </div>
      
      <p class="citation-list-snippet">{{ truncateSnippet(citation.snippet, 200) }}</p>
      
      <div class="citation-list-footer">
        <span class="citation-domain-text">{{ citation.domain }}</span>
        <mat-icon class="external-link-icon">open_in_new</mat-icon>
      </div>
    </div>
  </div>

  <!-- Compact Display Style (Perplexity Style Numbers) -->
  <div class="citations-compact" *ngIf="displayStyle === 'compact'">
    <div class="citations-compact-grid">
      <button
        mat-stroked-button
        class="citation-compact-button"
        *ngFor="let citation of displayedCitations; trackBy: trackByCitationId"
        (click)="openCitation(citation.url)"
        [matTooltip]="citation.title + ' - ' + citation.snippet"
        matTooltipPosition="above"
        matTooltipClass="citation-tooltip">
        <img 
          class="citation-favicon-tiny" 
          [src]="getFaviconUrl(citation.domain)" 
          [alt]="citation.domain"
          (error)="handleImageError($event)">
        {{ citation.id }}
      </button>
    </div>
  </div>

  <!-- Show More Button -->
  <div class="citations-show-more" *ngIf="citations.length > maxDisplay">
    <button mat-button (click)="maxDisplay = citations.length">
      Show {{ citations.length - maxDisplay }} more sources
      <mat-icon>expand_more</mat-icon>
    </button>
  </div>
</div>

<!-- Empty State -->
<div class="citations-empty" *ngIf="!citations || citations.length === 0">
  <mat-icon>info</mat-icon>
  <p>No sources available</p>
</div>

